import React, { useState } from 'react';
import {
  Box,
  Button,
  Divider,
  Drawer,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  Paper,
  TextField,
  InputAdornment,
  IconButton as MuiIconButton,
} from '@mui/material';
import { Person as PersonIcon, Edit as EditIcon } from '@mui/icons-material';
import { Minus, Plus, ShoppingCart, Trash, X } from '@phosphor-icons/react';
import { motion, AnimatePresence } from 'framer-motion';
import { POS_BG, POS_BORDER, POS_PRIMARY, POS_PRIMARY_HOVER, POS_PAY_GREEN, POS_PAY_GREEN_HOVER } from './stylesProductPercabang';
import { getApiBaseUrl } from './apiProductPercabang';
import { konfirmasi } from '../../../utils/dialog';
import { labelReservasiMeja, pesanKonfirmasiMeja } from '../../../utils/reservasiMeja';

export default function CartProductPercabang({
   isMobile,
   noted,
  setNoted,
   openMobile,
   setOpenMobile,
   products,
   orders,
   subtotal,
   total,
   ppnAktif,
   ppnPersenValue,
   ppnNominal,
   updateOrderNote,
   diskonPromo,
   promoNama,
   metode_pesanan,
   setMetode_pesanan,
   selectedTableId,
   setSelectedTableId,
   tables,
   reservasiMeja = {},
   takeawayList,
   selectedTakeawayName,
   setSelectedTakeawayName,
   onOpenCustomerDialog,
   customerSearchTerm,
   setCustomerSearchTerm,
   searchCustomers,
   ignoreNextCustomerFocusRef,
   customerSearchInputRef,
   selectedCustomer,
   clearSelectedCustomer,
   selectedPaymentMethod,
   setSelectedPaymentMethod,
   onPayClick,
   onSaveClick,
   incrementOrder,
   decrementOrder,
   removeOrder,
   formatCurrency,
   notificationSetter,
   processingPayment = false,
 }) {
  const getCartItemCount = () => orders.reduce((sum, i) => sum + i.quantity, 0);

  const CartContent = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            px: 1.5,
            py: 1.25,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: `1px solid ${POS_BORDER}`,
            backgroundColor: 'white',
          }}
        >
          
          {isMobile && (
            <>
              <Typography sx={{ fontWeight: 700, color: '#172b4d', fontSize: '0.95rem' }}>
                Keranjang{getCartItemCount() > 0 ? ` (${getCartItemCount()})` : ''}
              </Typography>
              <IconButton aria-label="Kembali" onClick={() => setOpenMobile(false)} size="small" sx={{ color: '#42526e', width: 32, height: 32 }}>
                <X size={20} />
              </IconButton>
            </>
          )}
        </Box>

        {metode_pesanan === 'dinein' && (
          <Box sx={{ px: 1.5, py: 1.5, backgroundColor: 'white', borderBottom: `1px solid ${POS_BORDER}` }}>
            <Typography variant="caption" sx={{ color: '#6b778c', fontWeight: 700, display: 'block', mb: 0.75, fontSize: '0.7rem' }}>
              Meja
            </Typography>
            <FormControl size="small" fullWidth sx={{ mb: 0.75 }}>
              <Select
                label="Meja"
                value={selectedTableId || ''}
                displayEmpty
                onChange={async (e) => {
                  const nilai = e.target.value || null;
                  // Meja yang sedang dipakai / segera dipakai tamu reservasi: kasir mengonfirmasi dulu (tamu sering memesan lagi di mejanya,
                  // tetapi pesanan untuk tamu lain di meja itu harus disengaja).
                  const info = nilai ? reservasiMeja[nilai] : null;
                  if (info) {
                    const nama = (tables.find((t) => (t.uuid || t.id) === nilai) || {}).name || 'ini';
                    if (!(await konfirmasi(pesanKonfirmasiMeja(nama, info), { judul: 'Meja direservasi', tombolYa: 'Ya, lanjutkan' }))) return;
                  }
                  setSelectedTableId(nilai);
                }}
                sx={{ borderRadius: 0.75, backgroundColor: '#f4f5f7', fontSize: '0.875rem' }}
              >
                <MenuItem value="">
                  <em>Pilih meja</em>
                </MenuItem>
                {tables.map((table) => {
                  const tid = table.uuid || table.id;
                  const tlabel = table.name || table.nomeja || 'Meja';
                  const info = reservasiMeja[tid];
                  return (
                    <MenuItem key={tid} value={tid}>
                      {tlabel}
                      {info && (
                        <Typography component="span" variant="caption" sx={{ ml: 1, color: info.jenis === 'datang' ? '#c62828' : '#b26a00', fontWeight: 700 }}>
                          {labelReservasiMeja(info)}
                        </Typography>
                      )}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>
        )}

        {metode_pesanan === 'takeaway' && (
          <Box sx={{ px: 1.5, py: 1.5, backgroundColor: 'white', borderBottom: `1px solid ${POS_BORDER}` }}>
            <Typography variant="caption" sx={{ color: '#6b778c', fontWeight: 700, display: 'block', mb: 0.75, fontSize: '0.7rem' }}>
              Metode Take Away
            </Typography>
            <FormControl size="small" fullWidth sx={{ mb: 0.75 }}>
              <Select
                label="Metode Take Away"
                value={selectedTakeawayName || ''}
                displayEmpty
                onChange={(e) => setSelectedTakeawayName(e.target.value || null)}
                sx={{ borderRadius: 0.75, backgroundColor: '#f4f5f7', fontSize: '0.875rem' }}
              >
                <MenuItem value="">
                  <em>Pilih metode</em>
                </MenuItem>
                {(takeawayList || []).map((t) => (
                  <MenuItem key={t.uuid} value={t.name}>
                    {t.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {(takeawayList || []).length === 0 && (
              <Typography variant="caption" sx={{ color: '#de9a00' }}>
                Belum ada pilihan take away.
              </Typography>
            )}
          </Box>
        )}

        <Box sx={{ px: 1.5, py: 1.5, backgroundColor: 'white', borderBottom: `1px solid ${POS_BORDER}` }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" sx={{ color: '#6b778c', fontWeight: 700, fontSize: '0.7rem' }}>
              Pelanggan
            </Typography>
            <Tooltip title="Pilih pelanggan">
              <IconButton
                onClick={onOpenCustomerDialog}
                size="small"
                sx={{
                  width: 28,
                  height: 28,
                  border: `0.5px solid ${POS_BORDER}`,
                  borderRadius: 0.75,
                  backgroundColor: '#f4f5f7',
                }}
              >
                <PersonIcon sx={{ color: '#42526e', fontSize: 16 }} />
              </IconButton>
            </Tooltip>
            {selectedCustomer && (
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="caption" sx={{ color: '#172b4d', fontSize: '0.8rem', display: 'block' }}>
                  {selectedCustomer.nama}
                </Typography>
                <Typography variant="caption" sx={{ color: '#6b778c', fontSize: '0.7rem' }}>
                  {selectedCustomer.telepon}
                </Typography>
              </Box>
            )}
            {selectedCustomer && (
              <IconButton size="small" onClick={clearSelectedCustomer} sx={{ p: 0.25, width: 24, height: 24 }}>
                <X size={12} />
              </IconButton>
            )}
          </Box>
        </Box>

        <Box sx={{ flex: 1, overflowY: 'auto', p: 1.5, backgroundColor: '#fafbfc' }}>
          {orders.length === 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 220 }}>
              <ShoppingCart size={48} color="#c1c7d0" weight="light" />
              <Typography variant="body2" sx={{ color: '#6b778c', mt: 2 }}>
                Belum ada item
              </Typography>
            </Box>
          ) : (
            <AnimatePresence>
              {orders.map((item) => {
                const product = products.find((p) => p.baranguuid === item.baranguuid);
                const thumb = product?.Barang?.foto ? `${getApiBaseUrl()}/uploads/${product.Barang.foto}` : null;
                return (
                  <motion.div
                    key={item.id}
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: 10 }}
                    transition={{ duration: 0.15 }}
                  >
                    <Box
                      sx={{
                        backgroundColor: 'white',
                        borderRadius: 1,
                        p: 1.25,
                        mb: 1,
                        border: `1px solid ${POS_BORDER}`,
                        '&:hover': { boxShadow: '0 2px 6px rgba(9, 30, 66, 0.08)' },
                      }}
                    >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      {/* Thumbnail */}
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: 1,
                          overflow: 'hidden',
                          flexShrink: 0,
                          backgroundColor: '#f4f5f7',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: 18,
                        }}
                      >
                        {thumb ? (
                          <img src={thumb} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <span role="img" aria-label="">🍽️</span>
                        )}
                      </Box>

                      {/* Item Info */}
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="body2" sx={{ color: '#172b4d' }}>
                          {item.name}
                        </Typography>
                        {item.selectedOptions && item.selectedOptions.length > 0 && (
                          <Typography variant="caption" sx={{ color: '#6b778c', display: 'block' }}>
                            {item.selectedOptions.map((o) => o.opsinama).join(', ')}
                          </Typography>
                        )}
                        <Typography variant="caption" sx={{ color: '#6b778c', display: 'block' }}>
                          Rp {formatCurrency(item.price)}
                          {item.grosir && <Box component="span" sx={{ ml: 0.75, color: 'success.main', fontWeight: 600 }}>Harga grosir</Box>}
                        </Typography>
                      </Box>

                      {/* Quantity & Price */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <IconButton
                          size="small"
                          onClick={() => decrementOrder(item.id)}
                          sx={{
                            width: 28,
                            height: 28,
                            padding: 0,
                            backgroundColor: '#f0f2f5',
                            border: `0.5px solid ${POS_BORDER}`,
                            borderRadius: 0.75,
                            '&:hover': { backgroundColor: '#e4e8ef' }
                          }}
                        >
                          <Minus size={12} />
                        </IconButton>
                        <Typography variant="body2"  sx={{ minWidth: 20, textAlign: 'center', color: '#172b4d' }}>
                          {item.quantity}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => incrementOrder(item.id)}
                          sx={{
                            width: 28,
                            height: 28,
                            padding: 0,
                            backgroundColor: POS_PRIMARY,
                            color: 'white',
                            borderRadius: 0.75,
                            '&:hover': { backgroundColor: POS_PRIMARY_HOVER },
                          }}
                        >
                          <Plus size={12} />
                        </IconButton>
                      </Box>

                      {/* Total Price */}
                      <Box sx={{ minWidth: 70, textAlign: 'right' }}>
                        <Typography variant="body2" sx={{ color: '#172b4d' }}>
                          Rp {formatCurrency(item.price * item.quantity)}
                        </Typography>
                      </Box>

                      {/* Delete */}
                      <IconButton
                        size="small"
                        onClick={() => removeOrder(item.id)}
                        sx={{
                          color: '#de350b',
                          p: 0.5,
                          width: 28,
                          height: 28,
                          '&:hover': { backgroundColor: '#ffebe6' }
                        }}
                      >
                        <Trash size={14} />
                      </IconButton>
                    </Box>
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="Catatan untuk item ini (opsional)"
                        value={item.catatan || ''}
                        onChange={(e) => updateOrderNote?.(item.id, e.target.value)}
                        sx={{
                          mt: 1,
                          '& .MuiOutlinedInput-root': {
                            fontSize: '0.75rem',
                            backgroundColor: '#f4f5f7',
                          },
                        }}
                      />
                    </Box>
                  </motion.div>
                );
              })}
            </AnimatePresence>
          )}
        </Box>

        <Box sx={{ p: 1.5, backgroundColor: 'white', borderTop: `1px solid ${POS_BORDER}` }}>
          {/* Totals Section */}
          <Box sx={{ mb: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="caption" sx={{ color: '#6b778c' }}>
                Subtotal
              </Typography>
              <Typography variant="caption"  sx={{ color: '#172b4d' }}>
                Rp {formatCurrency(subtotal)}
              </Typography>
            </Box>
            {diskonPromo > 0 && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="caption" sx={{ color: '#2e7d32', fontWeight: 700 }}>
                  Promo{promoNama ? `: ${promoNama}` : ''}
                </Typography>
                <Typography variant="caption" sx={{ color: '#2e7d32', fontWeight: 700 }}>
                  - Rp {formatCurrency(diskonPromo)}
                </Typography>
              </Box>
            )}
            {ppnNominal > 0 && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="caption" sx={{ color: '#6b778c' }}>
                  PPN {ppnPersenValue}%
                </Typography>
                <Typography variant="caption" sx={{ color: '#172b4d' }}>
                  Rp {formatCurrency(ppnNominal)}
                </Typography>
              </Box>
            )}
          </Box>

          <Divider sx={{ my: 0.75 }} />

           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 1.25 }}>
             <Typography variant="body2" fontWeight={900} sx={{ color: '#172b4d' }}>
               Total
             </Typography>
             <Typography variant="h6" fontWeight={900} sx={{ color: POS_PRIMARY }}>
               Rp {formatCurrency(total)}
             </Typography>
           </Box>

          <Divider sx={{ my: 0.75 }} />
           <Typography variant="caption" sx={{ fontWeight: 700, color: '#6b778c', display: 'block', mb: 0.75, fontSize: '0.7rem' }}>
  Noted
</Typography>
<TextField
  fullWidth
  size="small"
  placeholder="Tambahkan catatan pesanan..."
  value={noted}
  onChange={(e) => setNoted(e.target.value)}
  multiline
  rows={2}
  sx={{
    mb: 1.25,
    '& .MuiOutlinedInput-root': {
      borderRadius: 1,
      fontSize: '0.8rem',
      backgroundColor: '#f4f5f7',
      '& fieldset': { borderColor: POS_BORDER },
    },
  }}
/> 
          {/* Order Type Section */}
          <Typography variant="caption" sx={{ fontWeight: 700, color: '#6b778c', display: 'block', mb: 0.75, fontSize: '0.7rem' }}>
            Metode pesanan
          </Typography>
          <Box sx={{ display: 'flex', gap: 0.75, mb: 1.25 }}>
            {[
              { key: 'dinein', label: 'Dine in' },
              { key: 'takeaway', label: 'Takeaway' },
            ].map((method) => (
              <Button
                key={method.key}
                variant={metode_pesanan === method.key ? 'contained' : 'outlined'}
                size="small"
                onClick={() => {
                  setMetode_pesanan(method.key);
                  if (method.key === 'takeaway') setSelectedTableId(null);
                  if (method.key === 'dinein') setSelectedTakeawayName(null);
                }}
                sx={{
                  flex: 1,
                  textTransform: 'none',
                  borderRadius: 1,
                  
                  boxShadow: 'none',
                  fontSize: '0.8rem',
                  py: 0.75,
                  backgroundColor: metode_pesanan === method.key ? POS_PRIMARY : 'transparent',
                  color: metode_pesanan === method.key ? 'white' : POS_PRIMARY,
                  borderColor: POS_PRIMARY,
                  border: `1px solid ${POS_PRIMARY}`,
                  '&:hover': { 
                    boxShadow: 'none', 
                    backgroundColor: metode_pesanan === method.key ? POS_PRIMARY_HOVER : '#f0f2f5',
                    borderColor: POS_PRIMARY_HOVER,
                  },
                }}
              >
                {method.label}
              </Button>
            ))}
          </Box>

          <Divider sx={{ my: 0.75 }} />

          {/* Payment Methods Section */}
          {/* <Typography variant="caption" sx={{ fontWeight: 700, color: '#6b778c', display: 'block', mb: 0.75, fontSize: '0.7rem' }}>
            Metode pembayaran
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1.25 }}>
            {[
              { key: 'cash', label: 'Tunai' },
              { key: 'qris', label: 'QRIS' },
             
            ].map((method) => (
              <Button
                key={method.key}
                variant={selectedPaymentMethod === method.key ? 'contained' : 'outlined'}
                size="small"
                onClick={() => setSelectedPaymentMethod(method.key)}
                sx={{
                  flex: '1 1 calc(50% - 4px)',
                  minWidth: 'auto',
                  textTransform: 'none',
                 
                  fontSize: '0.75rem',
                  py: 0.6,
                  borderRadius: 1,
                  boxShadow: 'none',
                  backgroundColor: selectedPaymentMethod === method.key ? POS_PRIMARY : 'transparent',
                  color: selectedPaymentMethod === method.key ? 'white' : POS_PRIMARY,
                  borderColor: POS_PRIMARY,
                  border: `1px solid ${POS_PRIMARY}`,
                  '&:hover': { 
                    boxShadow: 'none', 
                    backgroundColor: selectedPaymentMethod === method.key ? POS_PRIMARY_HOVER : '#f0f2f5',
                    borderColor: POS_PRIMARY_HOVER,
                  },
                }}
              >
                {method.label}
              </Button>
            ))}
          </Box> */}

          <Divider sx={{ my: 0.75 }} />

          {/* Action Buttons */}
{/* Mobile: sisakan tempat untuk bilah navigasi bawah (±56px, menimpa drawer). Nilai px, bukan angka: angka di sx dikali 8 (96 = 768px dulu menggencet daftar item). */}
<Box sx={{ display: 'flex', gap: 0.75, pb: isMobile ? '72px' : 0 }}>
             <Button
               fullWidth
               variant="contained"
               size="small"
               onClick={onPayClick}
               disabled={processingPayment}
               sx={{
                 backgroundColor: POS_PAY_GREEN,
                
                 py: 1,
                 borderRadius: 1.25,
                 textTransform: 'none',
                 boxShadow: 'none',
                 fontSize: '0.85rem',
                 '&:hover': { backgroundColor: POS_PAY_GREEN_HOVER, boxShadow: 'none' },
               }}
             >
               {processingPayment ? 'Memproses...' : 'Bayar Sekarang'}
             </Button>
           
           </Box>
        </Box>
    </Box>
  );

  if (isMobile) {
    return (
      <Drawer
        anchor="right"
        variant="temporary"
        open={openMobile}
        onClose={() => setOpenMobile(false)}
        PaperProps={{
          sx: {
            width: '100%',
            backgroundColor: POS_BG,
            borderLeft: 'none',
            // Bilah atas KASIRKU (fixed, z-index 1300) lebih tinggi dari drawer: beri jarak sebesar tingginya supaya header
            // keranjang dan tombol tutup tidak tertutup.
            pt: { xs: '56px', sm: '64px' },
            boxSizing: 'border-box',
          },
        }}
        ModalProps={{ keepMounted: true }}
      >
        {CartContent}
      </Drawer>
    );
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 70,
        right: 12,
        bottom: 12,
        width: 430,
        zIndex: 1190,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          height: '100%',
          border: `1px solid ${POS_BORDER}`,
          borderRadius: 1.5,
          overflow: 'hidden',
          backgroundColor: 'white',
          boxShadow: '0 8px 24px rgba(9, 30, 66, 0.12)',
        }}
      >
        {CartContent}
      </Paper>
    </Box>
  );
}

